import MaterialTable from "@material-table/core";
import { Dialog, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
export default function PopupDashboardComponent(props) {
    const { dataDeploy, dataHotfix, dataHotRequest, titleDashboard, open, handleClose, headerDeploy, headerHotFix, headerHotRequest } = props;

    const [dataPlanDeploy, setDataDeploy] = useState([]);
    const [dataPlanHotfix, setDataHotfix] = useState([]);
    const [dataPlanHotRequest, setDataHotRequest] = useState([]);
    const tableRef = React.createRef();
    useEffect(() => {
        if (open) {
            setDataDeploy(dataDeploy && dataDeploy);
            setDataHotfix(dataHotfix && dataHotfix);
            setDataHotRequest(dataHotRequest && dataHotRequest);
        }
        // eslint-disable-next-line
    }, [open])

    return (
        <div>
            <Dialog
                open={open}
                maxWidth={'lg'}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{maxWidth: "1200px",marginLeft: "25%", marginRight: "5%"}}
            >
                <DialogTitle id="alert-dialog-title">
                    <div className="row">
                        <div className="col-11">
                            <span style={{ fontWeight: 'bold' }}>{titleDashboard}</span>
                        </div>
                        <div className="col-1" style={{ display: 'flex', justifyContent: 'center' }}>
                            <MdClose onClick={handleClose} />
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent>
                    {dataPlanDeploy && dataPlanDeploy.length > 0 &&
                        <DialogContentText id="alert-dialog-description">
                            <p style={{ color: 'black', fontWeight: 'bold' }}>KH Deployment</p>
                            <div>
                                <MaterialTable
                                    tableRef={tableRef}
                                    columns={headerDeploy && headerDeploy}
                                    data={dataPlanDeploy && dataPlanDeploy}
                                    style={{
                                        borderRadius: '20px',
                                        boxShadow: 'rgb(100 100 111 / 20%) 0px 7px 29px 0px',
                                        border: 'none',
                                    }}
                                    options={{
                                        tableLayout: "auto",
                                        toolbar: true,
                                        paging: true,
                                        pageSize: 5,
                                        exportButton: {
                                            csv: true,
                                            pdf: false,
                                        },
                                        exportAllData: true,
                                        filtering: true,
                                        selection: false,
                                        headerStyle: {
                                            backgroundColor: "var(--itsm-bg-btn)",
                                            color: "#FFF",
                                            marginTop: "1%",
                                            height: 100, maxHeight: 100, lineHeight: 1, textAlign: 'center', overflow: 'none',
                                            paddingRight: 0, paddingBottom: 0, paddingTop: 0
                                        },
                                        actionsColumnIndex: -1,
                                    }}
                                    localization={{
                                        pagination: {
                                            labelDisplayedRows: "Từ {from} - đến {to} of {count}",
                                        },
                                        toolbar: {
                                            exportCSVName: "Export danh sách chi tiết",
                                            nRowsSelected: "Đã chọn {0} dòng",
                                        },
                                        header: {
                                            actions: "",
                                        },
                                        body: {
                                            emptyDataSourceMessage: "Không có dữ liệu",
                                            deleteTooltip: "Xóa",
                                            filterRow: {
                                                filterTooltip: "Filter",
                                            },
                                            editRow: {
                                                deleteText: "Bạn đã thực sự chắc chắn muốn xóa?",
                                                cancelTooltip: "Hủy bỏ",
                                                saveTooltip: "Đồng ý",
                                            },
                                        },
                                    }}
                                    title=""
                                />
                            </div>
                        </DialogContentText>}

                    {dataPlanHotfix && dataPlanHotfix.length > 0 && <DialogContentText id="alert-dialog-description">
                        <p style={{ color: 'black', fontWeight: 'bold' }}>KH Hotfix</p>
                        <div>
                            <MaterialTable
                                tableRef={tableRef}
                                columns={headerHotFix && headerHotFix}
                                data={dataPlanHotfix && dataPlanHotfix}
                                style={{
                                    borderRadius: '20px',
                                    boxShadow: 'rgb(100 100 111 / 20%) 0px 7px 29px 0px',
                                    border: 'none',
                                }}
                                options={{
                                    tableLayout: "auto",
                                    toolbar: true,
                                    paging: true,
                                    pageSize: 5,
                                    exportButton: {
                                        csv: true,
                                        pdf: false,
                                    },
                                    exportAllData: true,
                                    filtering: true,
                                    selection: false,
                                    headerStyle: {
                                        backgroundColor: "var(--itsm-bg-btn)",
                                        color: "#FFF",
                                        marginTop: "1%",
                                        height: 100, maxHeight: 100, lineHeight: 1, textAlign: 'center', overflow: 'none',
                                        paddingRight: 0, paddingBottom: 0, paddingTop: 0
                                    }
                                    ,
                                    actionsColumnIndex: -1,
                                }}
                                localization={{
                                    pagination: {
                                        labelDisplayedRows: "Từ {from} - đến {to} of {count}",
                                    },
                                    toolbar: {
                                        exportCSVName: "Export danh sách chi tiết",
                                        nRowsSelected: "Đã chọn {0} dòng",
                                    },
                                    header: {
                                        actions: "",
                                    },
                                    body: {
                                        emptyDataSourceMessage: "Không có dữ liệu",
                                        deleteTooltip: "Xóa",
                                        filterRow: {
                                            filterTooltip: "Filter",
                                        },
                                        editRow: {
                                            deleteText: "Bạn đã thực sự chắc chắn muốn xóa?",
                                            cancelTooltip: "Hủy bỏ",
                                            saveTooltip: "Đồng ý",
                                        },
                                    },
                                }}
                                title=""
                            />
                        </div>
                    </DialogContentText>}
                    {dataPlanHotRequest && dataPlanHotRequest.length > 0 && <DialogContentText id="alert-dialog-description">
                        <p style={{ color: 'black', fontWeight: 'bold' }}>KH Hot Request</p>
                        <div>
                            <MaterialTable
                                tableRef={tableRef}
                                columns={headerHotRequest && headerHotRequest}
                                data={dataPlanHotRequest && dataPlanHotRequest}
                                style={{
                                    borderRadius: '20px',
                                    boxShadow: 'rgb(100 100 111 / 20%) 0px 7px 29px 0px',
                                    border: 'none',
                                }}
                                options={{
                                    tableLayout: "auto",
                                    toolbar: true,
                                    paging: true,
                                    pageSize: 5,
                                    exportButton: {
                                        csv: true,
                                        pdf: false,
                                    },
                                    exportAllData: true,
                                    filtering: true,
                                    selection: false,
                                    headerStyle: {
                                        backgroundColor: "var(--itsm-bg-btn)",
                                        color: "#FFF",
                                        marginTop: "1%",
                                        height: 100, maxHeight: 100, lineHeight: 1, textAlign: 'center', overflow: 'none',
                                        paddingRight: 0, paddingBottom: 0, paddingTop: 0
                                    }
                                    ,
                                    actionsColumnIndex: -1,
                                }}
                                localization={{
                                    pagination: {
                                        labelDisplayedRows: "Từ {from} - đến {to} of {count}",
                                    },
                                    toolbar: {
                                        exportCSVName: "Export danh sách chi tiết",
                                        nRowsSelected: "Đã chọn {0} dòng",
                                    },
                                    header: {
                                        actions: "",
                                    },
                                    body: {
                                        emptyDataSourceMessage: "Không có dữ liệu",
                                        deleteTooltip: "Xóa",
                                        filterRow: {
                                            filterTooltip: "Filter",
                                        },
                                        editRow: {
                                            deleteText: "Bạn đã thực sự chắc chắn muốn xóa?",
                                            cancelTooltip: "Hủy bỏ",
                                            saveTooltip: "Đồng ý",
                                        },
                                    },
                                }}
                                title=""
                            />
                        </div>
                    </DialogContentText>}
                </DialogContent>
            </Dialog>
        </div>
    )

}